/**
 * Copy for the public-mode teaser state (section share flag OFF): the tile keeps
 * its header + real count but withholds all content behind this lock line, which
 * names the hidden section and points at the app. The money tile pairs it with
 * the anonymous spend summary; every other section shows it alone. Kept in one
 * place so the wording swaps atomically; tests assert teaser absence via the
 * shared prefix.
 */
export const SECTION_TEASER_PREFIX = 'Login and join this trip to view'

export const sectionTeaserCopy = (sectionNoun: string): string => `${SECTION_TEASER_PREFIX} ${sectionNoun}`
